module.exports = __webpack_public_path__ + "static/media/rightAngleTriangle2.5151167d.svg";